import * as t from "@/lib/backend/manufacturing2.generated.types";

export function uniqueCompetentPersonUuids(competences: t.ILineCompetenceData[]): string[] {
    return [...new Set(competences.map(c => c.person_uuid))];
}

export function buildPersonActiveByUuid(people: t.IPersonData[]): Map<string, boolean> {
    const person_active_by_uuid = new Map<string, boolean>();
    for (const person of people) {
        person_active_by_uuid.set(person.uuid, person.active);
    }
    return person_active_by_uuid;
}

export function isCompetentPersonActive(
    person_uuid: string,
    person_active_by_uuid: Map<string, boolean>,
    enrichment_failed: boolean
): boolean {
    if (enrichment_failed) {
        return true;
    }
    const active = person_active_by_uuid.get(person_uuid);
    return active !== false;
}

export function countCompetentPeopleActive(
    competences: t.ILineCompetenceData[],
    person_active_by_uuid: Map<string, boolean>,
    enrichment_failed: boolean
): { active_count: number; total_count: number } {
    const total_count = competences.length;
    if (enrichment_failed) {
        return { active_count: total_count, total_count };
    }
    let active_count = 0;
    for (const competence of competences) {
        if (isCompetentPersonActive(competence.person_uuid, person_active_by_uuid, false)) {
            active_count++;
        }
    }
    return { active_count, total_count };
}

export function filterCompetencesByOnlyActive(
    competences: t.ILineCompetenceData[],
    only_active: boolean,
    person_active_by_uuid: Map<string, boolean>,
    enrichment_failed: boolean
): t.ILineCompetenceData[] {
    if (!only_active || enrichment_failed) {
        return competences;
    }
    return competences.filter(competence =>
        isCompetentPersonActive(competence.person_uuid, person_active_by_uuid, false)
    );
}
